import { CmsIconListItem, CmsMultiContent } from '@domgen/dgx-fe-cms';

export interface CmsApplianceDetailsAdditionalAppliancesBenefitsPanel {
  benefits: CmsMultiContent<CmsIconListItem>;
}
